// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"445":"8045886e","453":"13e7e887","914":"5bd498a0"}[chunkId] + ".chunk.js";
};